import React, { useRef, useEffect, useState } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange, dataTestidPrefix = "sig" }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.lineWidth = 2.5;
    ctx.strokeStyle = "#D4AF37";
  }, []);

  const getPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const touch = e.touches?.[0];
    const x = (touch ? touch.clientX : e.clientX) - rect.left;
    const y = (touch ? touch.clientY : e.clientY) - rect.top;
    return { x, y };
  };

  const start = (e) => {
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
    setDrawing(true);
  };

  const move = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
    setEmpty(false);
  };

  const end = () => {
    if (!drawing) return;
    setDrawing(false);
    const data = canvasRef.current.toDataURL("image/png");
    onChange?.(data);
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setEmpty(true);
    onChange?.(null);
  };

  return (
    <div className="border border-[color:var(--border)] rounded-xl overflow-hidden bg-[color:var(--bg-surface)]">
      <div className="px-4 py-2 flex items-center justify-between border-b border-[color:var(--border)]">
        <span className="label-caps">Manager Signature</span>
        <button
          type="button"
          onClick={clear}
          data-testid={`${dataTestidPrefix}-clear-btn`}
          className="flex items-center gap-1 text-xs text-[color:var(--text-secondary)] hover:text-[color:var(--gold)]"
        >
          <Eraser size={14} /> Clear
        </button>
      </div>
      <canvas
        ref={canvasRef}
        data-testid={`${dataTestidPrefix}-canvas`}
        className="w-full h-40 sm:h-48 touch-none cursor-crosshair"
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
      />
      {empty && (
        <div className="text-center text-xs text-[color:var(--text-disabled)] pb-2 -mt-24 pointer-events-none">
          Sign above with finger, mouse, or stylus
        </div>
      )}
    </div>
  );
}
